import { PARTNER360_NAMESPACE } from 'legacy/lut/features/partner360/common/constants'

export const PARTNER360_FIN_COCKPIT_NAMESPACE = `${PARTNER360_NAMESPACE}/finCockpit`

// Async thunk constants
export const REQUEST_FIN_COCKPIT = `${PARTNER360_FIN_COCKPIT_NAMESPACE}/requestFinCocpit`
export const FIN_COCKPIT_DOWNLOAD_TYPE_PREFIX = `${PARTNER360_FIN_COCKPIT_NAMESPACE}/downloadWithProgress`

export const COCKPIT_FIN_FRACTION_DIGITS = 1

// Set to true to allow opening the MDF activity editor only for the current fiscal year.
export const COCKPIT_MDF_EDIT_CURRENT_FYEAR_ONLY = false

// Set to false to restore the original RTM card, filter modes and selected-filter bubbles.
export const COCKPIT_UNIFIED_FILTER_PANEL_ENABLED = true
